// @mui
import { Stack } from '@mui/material';
// auth
// locales
// routes

// ----------------------------------------------------------------------

export default function NavDocs() {
  return (
    <Stack
      spacing={3}
      sx={{
        px: 5,
        pb: 5,
        mt: 10,
        width: 1,
        display: 'block',
        textAlign: 'center',
      }}
    />
  );
}
